// extracted by mini-css-extract-plugin
export var chip = "_67-9";
export var chipLabel = "_67-a";
export var close = "_67-7";
export var closeIcon = "_67-8";
export var error = "_67-6";
export var infoTooltip = "_67-2";
export var innerContainer = "_67-1";
export var input = "_67-b";
export var medium = "_67-5";
export var outerContainer = "_67-0";
export var small = "_67-4";
export var xSmall = "_67-3";